<template>
  <a-page-header
    class="available-networks"
  >
    <span slot="title">
      {{ 'supported-network-info.title' | globalize }}
    </span>
    <span
      slot="subTitle"
      :key="value.chainId"
      v-for="(value) in info">
      <span class="available-networks-info">{{ value.chainId }}:{{ value.name }}</span>
    </span>
  </a-page-header>
</template>

<script>
import APageHeader from 'ant-design-vue/lib/page-header'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { SessionStorageService } from '@/js/session-storage'
import { api } from '@/api'
import { Bus } from '@/js/helpers/event-bus'

export default {
  name: 'supported-network-info',
  components: {
    'a-page-header': APageHeader,
  },
  data () {
    return {
      storage: new SessionStorageService('sn'),
      info: [],
    }
  },
  async created () {
    this.info = this.storage.get()
    if (!this.info) {
      const { data } = await this.getData()
      this.info = data.map(row => {
        return {
          chainId: row.chainId,
          name: row.name,
          subgraphUrl: row.subgraphUrl,
          explorerUrl: row.explorerUrl,
        }
      })
      this.storage.set(this.info)
    }

    Bus.on('supported-network-list-updated', (value) => {
      this.info = value.map(row => {
        return {
          chainId: row.chainId,
          name: row.name,
          subgraphUrl: row.subgraphUrl,
          explorerUrl: row.explorerUrl,
        }
      })
      this.storage.set(this.info)
    })
  },

  destroyed () {
    Bus.resetEvent('supported-network-list-updated')
  },

  methods: {
    async getData () {
      let response = {}
      try {
        response = await api.getWithSignature('/supported-networks')
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }

      return response
    },
  },
}
</script>

<style scoped lang="scss">
@import '~ant-design-vue/lib/page-header/style/index.css';
@import '~@scss/variables';

.available-networks.ant-page-header {
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  margin-bottom: 0;

  .available-networks-info {
    padding: 0.4em;
    margin-right: 0.3em;
    background: $_white;
    border: 0.001em solid $_gray;
  }
}

</style>
